export default __webpack_public_path__ + "static/3-3ab7d3c5c9d4199009f65022b8d40d38.jpg";